
import { IAcademicPeriod, IAcademicPeriodsParams, ITableRes } from 'types'

import { baseApi } from './baseApi'
import { MAX_PER_PAGE } from 'utils/constants'

export const academicPeriodsAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_academicPeriods: builder.query<ITableRes<IAcademicPeriod>, IAcademicPeriodsParams>({
      query: (params) => {
        return {
          url: `/academic-periods/`,
          params
        }
      },
      providesTags: ['academic-periods'],
    }),
    GET_academicPeriodById: builder.query<IAcademicPeriod, string>({
      query: (id) => {
        return {
          url: `/academic-periods/${id}/`,
        }
      },
      providesTags: ['academic-period'],
    }),
    POST_academicPeriod: builder.mutation<IAcademicPeriod, IAcademicPeriod>({
      query: (body) => ({
        url: `/academic-periods/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['academic-periods'],
    }),
    PUT_academicPeriod: builder.mutation<IAcademicPeriod, { id: string; body: IAcademicPeriod }>({
      query: ({ id, body }) => ({
        url: `/academic-periods/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['academic-periods', 'academic-period'],
    }),
    DELETE_academicPeriod: builder.mutation<IAcademicPeriod, string>({
      query: (id) => ({
        url: `/academic-periods/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['academic-periods'],
    }),
     // Selects
     GET_academicPeriodsSelect: builder.query<any, {group_course: number}>({
      query: (params) => ({
        url: '/academic-periods/select/',
        params: {...params, page_size: MAX_PER_PAGE},
      }),
      transformResponse: (response: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        return {
          list: response?.results || [],
          count,
          hasMore,
        }
      },
      providesTags: ['academic-periods-select'],
    }),
  }),
})

export const {
  useGET_academicPeriodsQuery,
  usePOST_academicPeriodMutation,
  useGET_academicPeriodByIdQuery,
  usePUT_academicPeriodMutation,
  useDELETE_academicPeriodMutation,
  useGET_academicPeriodsSelectQuery,
} = academicPeriodsAPI
